import { useState, useEffect } from "react";

// components
import { Button } from "shared/components/bulma/button";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";

// internal components
import { EmailStatusTag } from "./email-status-tag";

// helpers
import * as helper from './helper';

const ResetPassword = ({ customer }) => {

    const [loading, setLoading] = useState(false);
    const [showLogs, setShowLogs] = useState(false);
    const [emailStatusInfo, setEmailStatusInfo] = useState({});

    const handleClick = async () => {
        if (!window.confirm('Are you sure you want to reset the password?')) {
            return;
        }

        setLoading(true);
        setEmailStatusInfo({ delivery: { state: 'STARTING' } });

        try {
            await helper.sendResetPasswordEmail(customer);
            await getData();
        } catch (error) {
            setEmailStatusInfo({ state: 'ERROR', error });
            setLoading(false);
        }
    }

    const getData = async () => {
        let currentState = '';
        const i = setInterval(async () => {
            if (currentState === 'SUCCESS') {
                clearInterval(i);
                setLoading(false);
                return;
            }

            const data = await helper.getPasswordResetEmail(customer);
            if (data?.delivery) {
                setEmailStatusInfo(data);
                currentState = data.delivery.state;
            }
        }, 1_000);
    }

    const toggleShowLogs = () => {
        setShowLogs(!showLogs);
    }

    const DisplayLink = () => {
        if (!emailStatusInfo?.message?.html) {
            return null;
        }

        return (
            <ClipboardCopy value={helper.extractLastResetLinkFromEmail(emailStatusInfo.message.html)}>
                <small>
                    <span className="icon-text">
                        <span className="icon">
                            <i className="fas fa-mouse"></i>
                        </span>
                        <span>Click me to copy the reset link</span>
                    </span>
                </small>
            </ClipboardCopy>
        );
    }

    useEffect(() => {
        const getInitialData = async () => {
            if (!customer?.id) {
                return;
            }

            const data = await helper.getPasswordResetEmail(customer);
            if (!data?.delivery) {
                return;
            }

            setEmailStatusInfo(data);
        }

        getInitialData();
    }, [customer]);

    return (
        <>
            <Button className={`${loading ? 'is-loading' : ''}`} onClick={handleClick} disabled={loading}>
                Send Customer a Password Reset Link
            </Button>
            <div className="mt-2">
                <EmailStatusTag data={emailStatusInfo} />
                <DisplayLink />
            </div>

            {loading && <progress className="mt-4 progress is-small is-primary" max="100">15%</progress>}

            <Button className="is-small is-light mt-6" onClick={toggleShowLogs}>
                <span className="icon-text">
                    <span className="icon">
                        <i className={`fas ${showLogs ? 'fa-minus-square' : 'fa-plus-square'}`}></i>
                    </span>
                    <span>{showLogs ? 'Hide logs' : 'Show logs'}</span>
                </span>
            </Button>
            {showLogs && <pre className="mt-1">{JSON.stringify(emailStatusInfo, undefined, 4)}</pre>}
        </>
    );
};

export { ResetPassword };
